<template>
    <div id="bankTransferList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                  <div class="page-title"> Debt Payment Reconciliation Post</div>

                  <div class="btn-groups text-right">

                      <button v-if="noteStatus != 'Complete'" type="submit" class="btn btn-secondary" v-on:click.prevent="postVoucher(false)" >
                              <i class="fp-save"> </i> Post
                      </button>

                      <button v-if="noteStatus === 'Complete' && canUnpost" type="submit" class="btn btn-secondary" v-on:click.prevent="postVoucher(true)" >
                        <i class="fp-save"> </i> Unpost
                      </button>

                      <button type="submit" class="btn btn-secondary" v-on:click.prevent="backScreen" >
                              <i class="fp-back"> </i> Back
                      </button>
                  </div>

                </div>


                <div class="container-fluid">
                    <div class="admin-page-content debt-recon-view">
                        <section class="internal-container border-top-table-fl" >
                            <div class="form-row">
                                <div class="col-4 form-group">
                                    <div class="form-row">
                                        <label class="col">Posting Date:</label>
                                        <span class="col label"> {{ post_date }} </span>
                                    </div>
                                </div>
                                <div class="col-4 form-group">
                                    <div class="form-row">
                                        <label class="col">Run Number:</label>
                                        <span class="col label"> {{ run_number }} </span>
                                    </div>
                                </div>
                                <div class="col-4 form-group">
                                    <div class="form-row">
                                        <label class="col">Financier:</label>
                                        <span class="col label"> {{ financier }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mt-3">
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col-3 control-label require"> Total Amount: </label>
                                        <span v-if="noteStatus != 'Complete'" class="col-6">
                                            <input type="text" class="form-control" v-model="total_amount" id="total_amount"
                                            placeholder="Total Amount" name="total_amount"
                                            @keypress="isNumber($event)"
                                            @blur="total_amount = leaveFocus($event)"
                                            @focus="total_amount = enterVal($event)">
                                            <div class="field-error">{{total_amount_error_msg}}</div>
                                        </span>

                                        <span v-if="noteStatus == 'Complete'" class="col-6">
                                           $ {{ amountFormat(total_amount) }}
                                        </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label id="gl_acc_req" class="col-3"> Var. Account: </label>
                                        <span class="col-6">
                                            <v-select v-model="gl_account" name="gl_account" id="gl_account" label="text"
                                                :filterable="false" :options="glAccountArr"
                                                @search="onSearchGLAccount" placeholder="Select GL-Account." class="custom-ci-auto-search contract-data">
                                                <template slot="no-options">
                                                    Search GL Account...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>

                                            <div class="field-error">{{gl_account_error_msg}}</div>
                                        </span>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col-3"> Variance Amount: </label>
                                        <span class="col label"> $ {{ amountFormat(variance_amount) }} </span>
                                    </div>

                                    <div class="form-row form-group">
                                        <label class="col-3 control-label require"> Invoice Number: </label>
                                        <span v-if="noteStatus != 'Complete'" class="col-6">
                                            <input type="text" class="form-control" v-model="invoice_number" id="invoice_number"
                                            placeholder="Invoice Number" name="invoice_number">
                                            <div class="field-error">{{invoice_number_error_msg}}</div>
                                        </span>

                                        <span v-if="noteStatus == 'Complete'" class="col-6">
                                            {{invoice_number}}
                                        </span>
                                    </div>
                                </div>


                            </div>

                        </section>
                        <p v-if="batchProcess" class="alert-success p-2" v-fp-html="debtpostmsg"></p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>

                        <section class="view-page-table bg-white data-table border-top-table-fl">
                              <vue-good-table
                                  ref="debtNoteInterestList"
                                  title="Debt Note Interest List"
                                  @on-selected-rows-change="selectionChanged"
                                  :columns="columns"
                                  :rows="rows"
                                  :totalRows="totalRecords"
                                  :pagination-options="{
                                      enabled: true,
                                      position:'top',
                                      mode: 'records',
                                      perPage: 50,
                                      perPageDropdown:[50,100],
                                      dropdownAllowAll: false,
                                  }"
                                  :search-options="{
                                      enabled: false,
                                      placeholder: 'Search Debt Note Interest rate',
                                  }"
                                  :select-options="{
                                      enabled: false,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                  }"
                                  :sort-options="{
                                      enabled: true,
                                  }"
                                  >
                                  <div slot="emptystate">
                                      No Data Found.
                                  </div>
                                  <!--div slot="selected-row-actions">
                                      <button id="postMileageBtn" v-on:click.prevent="postMileage()" class="btn btn-primary">Post</button>
                                      <button id="removeDiscaredBtn" v-on:click.prevent="removeDiscarded('')" class="btn btn-primary">Delete</button>
                                  </div-->
                              </vue-good-table>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import EventBus from ".././event-bus";

import {commonMixins} from '../../mixins/commonMixins';
// import {dataTableMixins} from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';
let msgServer
export default {
    name: "debtNoteInterestList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Notes Interest List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
      noteStatus: "",
      permissions:[],
      cantAccessPage:'',
      loading:false,
      userColumns: [],
      columns: [
            {
                label: 'Unit Number',
                field: 'unit_number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Unit Number', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Schedule Date',
                field: 'payment_date',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Schedule Date', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: self.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Note Reference Number',
                field: 'reference_number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Note Reference Number', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Principal',
                field: 'principal_payment',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Principal', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Interest',
                field: 'interest',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Interest', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Total',
                field: 'total',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Total', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Facility',
                field: 'location',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Facility', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Pool',
                field: 'pool_code',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Pool', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
      ],
      rows: [],
      totalRecords: 0,
      note_amount: 0,
      start_date: '',
      status: '',
      reference_number: '',
      financier: '',
      number_of_payment: '',
      total_interest: '',
      rate: '',
      statusArr: ['Entered', 'Active', 'Closed'],
      glAccountArr: [],
      gl_account: '',
      post_date: '',
      run_number: '',
      total_amount: '',
      total_amount_error_msg: '',
      asset_number: '',
      variance_amount: '',
      main_variance_amount: '',
      gl_account_error_msg: '',
      invoice_number: '',
      invoice_number_error_msg: '',
      batch_id:'',
      batchNum:'',
      debtpostmsg:'',
      batchProcess:false,
      batchError:false,
      batchErrorMsg:'',
      canUnpost: false,
      isReverse: false,
      payment_number: ''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_debt_note_reconciliation') {
                    self.cantAccessPage = true;
                }
              if(permissions.name == 'unpost_gl') {
                self.canUnpost = true;
              }
            });
        },
        total_amount: function (total_amount) {
          var self = this;
          var amount = 0;
          var totalAmount = 0

          if (self.total_amount != "" && self.total_amount != ".") {
              totalAmount += parseFloat(self.removeFormat(self.total_amount));
          }

          if (totalAmount == 0 || self.total_amount == '') {
              self.variance_amount = parseFloat(self.main_variance_amount);
              self.variance_amount =  ( -self.variance_amount ); // ~self.variance_amount + 1;
              $("#gl_acc_req").removeClass("require");
          }else{
              self.variance_amount = parseFloat(self.main_variance_amount) - totalAmount;
              self.variance_amount = ( -self.variance_amount ); //~self.variance_amount + 1;
          }

          if(self.variance_amount == '0.00') {
            $("#gl_acc_req").removeClass("require");
          } else {
            $("#gl_acc_req").addClass("control-label require");
          }


        },
    },
    created: function() {
    },
    mounted: function () {
      var self = this;
      self.getPermissions();
      self.loadList();


    },
    beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    methods: {
        checkBatchStatus:function(){
            var self =  this;

            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batch_id, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        if (data.other_params == null){
                          self.debtpostmsg = 'Un-posting successful,voucher has been deleted successfully';
                        }else{
                          self.debtpostmsg = 'Voucher created please <a href="/vendor-invoice/view/'+data.other_params+'" target="_blank">Click Here</a> to check invoice';
                        }
                        setTimeout(function(){
                            self.debtpostmsg = '';
                            self.batchProcess = false;
                            self.batchNum = '';
                        },7000);

                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        if (self.isReverse){
                          self.debtpostmsg = 'Debt note not un-posted';
                        }else{
                          self.debtpostmsg = 'Debt note not posted';
                        }
                        self.batchProcess = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }else if (data.status == "3") {
                      if (self.isReverse){
                        self.debtpostmsg = 'Debt note not un-posted because the next installment in sequence is posted.';
                      }else{
                        self.debtpostmsg = 'Debt note not posted';
                      }
                      self.batchProcess = false;
                      self.batchError = true;
                      self.batchErrorMsg = self.debtpostmsg;
                      sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },

      postVoucher: function (isUnpost) {
        var self = this;

        var error = false;

        self.total_amount_error_msg = '';
        self.gl_account_error_msg = '';
        self.invoice_number_error_msg = '';
        if (isUnpost){
          self.isReverse = true;
          self.$swal({
            title: 'Are you sure to Unpost the Voucher',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCloseButton: false,
            showLoaderOnConfirm: true
          }).then((result) => {
            if (result.value) {
              self.postVaoucherClick(isUnpost);

            } else {
              console.log("no");
            }
          });
        }else{
          if(self.invoice_number == '' || self.invoice_number == 0) {
            self.invoice_number_error_msg = "Invoice Number is required.";
            error = true;
          }

          if(self.total_amount == '' || self.total_amount == 0) {
            self.total_amount_error_msg = "Total Amount is required.";
            error = true;
          } else {

            if(self.variance_amount != 0.00) {

              if(self.gl_account == '' || !self.gl_account ) {
                $("#gl_acc_req").addClass("control-label require");
                self.gl_account_error_msg = 'Please select GL Account';
                error = true;
              } else {
                $("#gl_acc_req").removeClass("require");
              }

            } else {
              $("#gl_acc_req").removeClass("require");
            }

          }

          if(!error) {
            self.$swal({
              title: 'Are you sure to Post the Voucher',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                self.postVaoucherClick(isUnpost);

              } else {
                console.log("no");
              }
            });
          }
        }
      },
      postVaoucherClick(isUnpost) {
        var self = this;
        // console.log("YES" , self.gl_account);
        // console.log("YES" , parseFloat(self.variance_amount));

        var path = window.location.pathname;
        var segments = path.split("/");

        var glAccId = '';
        if(self.gl_account != null && self.gl_account != '') {
          glAccId = self.gl_account.value;
        }
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/debtpayment/reconciliation/post",
          type: "POST",
          data: {
            id: segments[4],
            invoice_number: self.invoice_number,
            gl_account: glAccId,
            amount: self.removeFormat(self.total_amount),
            variance_amount: parseFloat(self.variance_amount).toFixed(2),
            isReverse: isUnpost
          },
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
              self.loading = false;

              if (data.status == "success") {
                  console.log("res =", data.content);
                  if (data.content.batch){
                    self.batch_id = data.content.id;
                    self.batchNum = data.content.batch;
                    self.batchProcess = true;
                    if (self.isReverse){
                      self.debtpostmsg = 'Current batch '+ self.batchNum+ ' for debt un-posting is processing please wait!';
                    }else{
                      self.debtpostmsg = 'Current batch '+ self.batchNum+ ' for debt posting is processing please wait!';
                    }
                    self.checkBatchStatus();
                  }

                //   if(data.content.bill_id > 0) {
                //     self.$swal('','Voucher Created Successfully','info');
                //     setTimeout(function () {
                //         self.$router.push("/vendor-invoice/view/"+ data.content.bill_id);
                //     }, 1000);
                //   } else {
                //     setTimeout(function () {
                //         self.backScreen();
                //     }, 1000);
                //   }


              }else{
                  self.$swal('',data.content,'info');
              }
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              if (jqXHR.status == 0) {
                  self.errorMsg = "Remote server cannot be reached";
              } else {
                  //redirect to login page if user not authenticated
                  if (jqXHR.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("tkn");
                      self.$router.push("/");
                  }
                  self.error = jqXHR.responseJSON.message;
              }
          }
      });

      },

      // calculatePostAmount:function(evt, isCal = false) {
      //   var self = this;
      //   evt = (evt) ? evt : window.event;
      //   var charCode = (evt.which) ? evt.which : evt.keyCode;

      //   var amount = 0;
      //   var totalAmount = 0



      //   if(charCode == 13 || isCal == true) {
      //     // totalAmount = self.variance_amount -  evt.target.value;
      //     // self.variance_amount = totalAmount;
      //   } else if(charCode == 8) {
      //     // self.variance_amount = self.main_variance_amount;
      //   }

      //   // total_amount

      //   // variance_amount

      // },

      onSearchGLAccount(search, loading) {
          var self = this;
          if (search.length > 1) {
              loading(true);
              self.searchField(loading, search, 'gl_account', '');
          }
      },

      cancelAll: function (cancelAll) {
        this.$refs.debtNoteInterestList.unselectAllInternal();
      },
      backScreen(){
          this.$router.go(-1);
      },
      loadList() {

         var self = this;

        var filterArr = {};

        var path = window.location.pathname;
        var segments = path.split("/");

        var recDate = localStorage.getItem('rec_date');

          self.loading = true;
          var fields = {
              id: segments[4],
              rec_date: recDate,
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/debtpayment/reconciliation/detail",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      if(self.totalRecords > 0) {
                        self.financier = data.content.financier;
                        self.post_date = data.content.posting_date;
                        self.run_number = data.content.posting_run_number;
                        self.variance_amount = data.content.posting_amount;
                        self.variance_amount = ( -self.variance_amount ); //~self.variance_amount + 1;
                        self.main_variance_amount = data.content.posting_amount;
                        self.noteStatus = data.content.status;
                        if(self.noteStatus == "Complete") {
                          self.total_amount = self.amountFormat(data.content.posting_amount);
                          self.invoice_number = data.content.invoice_number;
                          self.payment_number = data.content.payment_number;
                          if (self.payment_number == null){
                            self.canUnpost = true;
                          }else{
                            self.canUnpost = false;
                          }
                          self.variance_amount = data.content.posting_variance;
                        }else{
                          self.total_amount = '';
                          self.invoice_number = '';
                          self.gl_account = '';
                        }
                      } else {
                        self.variance_amount = 0.00;
                        self.$swal('','No Records found please reload if there are records available in for this reconciliation','info');
                        // setTimeout(function () {
                        //     self.loadList();
                        // }, 1000);
                      }

                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.data.totalRecords;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if (jqXHR.status == 0) {
                      self.errorMsg = "Remote server cannot be reached";
                  } else {
                      //redirect to login page if user not authenticated
                      if (jqXHR.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("tkn");
                          self.$router.push("/");
                      }
                      self.error = jqXHR.responseJSON.message;
                  }
              }
          });

      },
    },
}
</script>





// WEBPACK FOOTER //
// src/components/payment/DebtPaymentReconciliationView.vue